import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { commonApi } from 'core/api/common.api';
import { setAxiosAuth } from 'utils';

export const useGetLocations = ({ accessToken = '' }) => {
  setAxiosAuth(accessToken);

  return useQuery({
    queryKey: [queryKeys.locations],
    queryFn: async () => await commonApi.getLocationList("ACTIVE"),
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(accessToken),
  });
}
